import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlidesTall"><Path d="M15.5 6.5V2.5H4.5V17.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 6.5H8.5V21.5H19.5V6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlidesTall;
